export type TExpandedViewContainerProps = {
  data: any;
  isRecent?: boolean;
  isNewSearch?: boolean;
  isFavorite?: boolean;
  isWatchedLoads?: boolean;
  isMyLoads?: boolean;
};

export const ExpandedViewNavigation = [
  { seq: 1, label: 'Map', slug: 'map' },
  { seq: 2, label: 'Rate', slug: 'rate' },
  { seq: 3, label: 'References', slug: 'references' },
  { seq: 4, label: 'Commodities', slug: 'commodities' },
  { seq: 5, label: 'Services', slug: 'services' },
  { seq: 6, label: 'Documents', slug: 'documents' },
];
